import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import banner2 from "../assets/ppe.jpg";
import { FaArrowRight } from "react-icons/fa";

export default function HomeBanner22() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  const offerings = [
    {
      title: "Seed Production & Multiplication",
      copy: "Producing high-quality, climate-resilient seeds through own farms and contracted growers.",
    },
    {
      title: "Agro-input Supply & Distribution",
      copy: "Supplying certified agrochemicals, fertilizers, and seeds through reliable distribution networks.",
    },
    {
      title: "Poultry Inputs & Farmer Support",
      copy: "Providing quality day-old chicks, poultry feeds, and technical guidance to improve farm performance.",
    },
  ];

  return (
    <section
      className="MainBodySection py-5"
      style={{
        background:
          "radial-gradient(circle at 85% 18%, rgba(7, 135, 90, 0.12), transparent 40%), linear-gradient(180deg, #ffffff 0%, #f3f9f5 100%)",
      }}
    >
      <div className="container">
        <div
          className="row g-4 align-items-stretch"
          style={{
            borderRadius: "26px",
            overflow: "hidden",
            boxShadow: "0 20px 50px rgba(10, 37, 24, 0.10)",
            background: "#ffffff",
            border: "1px solid rgba(15, 23, 42, 0.08)",
          }}
        >
          <div className="col-lg-7 p-4 p-lg-5 d-flex flex-column justify-content-center" data-aos="fade-up">
            <h2 className="font-bold text-primary mb-3">What We Do</h2>
            <p className="text-muted mb-4" style={{ lineHeight: 1.7 }}>
              We deliver integrated agribusiness solutions that strengthen agricultural productivity,
              sustainability, and food security. Our operations combine commercial-scale production,
              technology-driven processes, and farmer-centered services.
            </p>

            <div className="row g-3 mb-4">
              {offerings.map((item) => (
                <div className="col-12" key={item.title}>
                  <div
                    className="h-100 p-3 p-md-4"
                    style={{
                      borderRadius: "16px",
                      border: "1px solid rgba(30, 41, 59, 0.09)",
                      background: "linear-gradient(180deg, #ffffff 0%, #f8fbf9 100%)",
                    }}
                  >
                    <h6 className="font-bold text-secondary mb-2">{item.title}</h6>
                    <p className="text-muted mb-0 small">{item.copy}</p>
                  </div>
                </div>
              ))}
            </div>

            <button
              className="btn btn-secondary btn-padded"
              onClick={() => appContext.navTo({ item: "services" })}
              style={{
                background: "transparent",
                border: "none",
                padding: 0,
                fontWeight: "700",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              Explore Our Services <FaArrowRight />
            </button>
          </div>

          <div className="col-lg-5 p-3 p-lg-4 d-flex">
            <div
              style={{
                position: "relative",
                width: "100%",
                minHeight: "420px",
                borderRadius: "22px",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  background: "linear-gradient(170deg, rgba(7, 135, 90, 0.08), rgba(255, 255, 255, 0.00))",
                  zIndex: 1,
                }}
              />
              <img
                src={banner2}
                alt="Integrated agribusiness solutions"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
